import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { ComboCliente, ComboEstado, ComboGrupo, ComboInformesTipos, ComboSerieDocumental, ComboTipoServicio } from '../model/combos';
import { Idiomas } from '../model/idiomas';
import { Provincias } from '../model/provincias';



@Injectable()
export class PopulateService {

  PATH = '';
  PATH_LANGUAGES = '';
  PATH_CLIENTES = '';
  PATH_TYPE_SERVICES = '';
  PATH_INFORMES = '';
  PATH_PROVEEDORES = '';

  constructor(private http: HttpClient) {

    this.PATH = environment.API_BASE + '/Dirs/Provincias';
    this.PATH_LANGUAGES = environment.API_BASE + '/Users/GetIdiomas';
    this.PATH_CLIENTES = environment.API_BASE + '/Clients';
    this.PATH_TYPE_SERVICES = environment.API_BASE + '/Services';
    this.PATH_INFORMES = environment.API_BASE + '/Informes';
    this.PATH_PROVEEDORES = environment.API_BASE + '/Proveedores';
  }

  getAllProvincias(): Observable<Provincias[]> {
    return this.http.get<Provincias[]>(this.PATH).pipe(map((provincias: Provincias[]) =>
      provincias.map((provincia: Provincias) => Provincias.toModel(JSON.stringify(provincia)))));
  }

  getLanguagesAvailables(): Observable<Idiomas[]> {
    return this.http.get<Idiomas[]>(this.PATH_LANGUAGES);
  }

  getComboCliente(): Observable<ComboCliente[]> {
    return this.http.get<ComboCliente[]>(this.PATH_CLIENTES + '/GetClientsName');
  }


  // region "Combo Servicios"

  getComboTipoServicioByCliente(idcliente?: number): Observable<ComboTipoServicio[]> {
    return this.http.get<ComboTipoServicio[]>(this.PATH_TYPE_SERVICES + '/GetTypesSolution/' + idcliente);

  }




  getComboEstado(idcliente: number, idtiposervicio: number, idSolicitud: number): Observable<ComboEstado[]> {
    if (typeof idcliente !== 'undefined' && !idcliente) {
      idcliente = -1;
    }

    return this.http.get<ComboEstado[]>(this.PATH_TYPE_SERVICES + '/Situation/GetStatusServicio/' + idcliente + '/' + idtiposervicio + '/' + idSolicitud)
      .pipe(map((cbestados: ComboEstado[]) =>
        cbestados.map((cbestado: ComboEstado) => ComboEstado.toModel(JSON.stringify(cbestado)))));
  }



  getComboEstadoGenerales(idcliente: number, idservicio: number): Observable<ComboEstado[]> {
    if (!idcliente) {
      idcliente = -1;
    }
    return this.http.get<ComboEstado[]>(this.PATH_TYPE_SERVICES + '/GetTypesEspecific/' + idcliente + '/' + idservicio)
      .pipe(map((cbestados: ComboEstado[]) =>
        cbestados.map((cbestado: ComboEstado) => ComboEstado.toModel(JSON.stringify(cbestado)))));
  }

  getComboSerieDocumentales(idcliente?: number, iddepartamento?: number): Observable<ComboSerieDocumental[]> {
    return this.http.get<ComboSerieDocumental[]>(this.PATH_TYPE_SERVICES + '/GetFiltroSeriesDocumental/' + idcliente + '/' + iddepartamento);
  }

  getComboDepartamentos(idcliente?: number): Observable<{ Id: number, DESCRIPCION: string }[]> {
    return this.http.get<{ Id: number, DESCRIPCION: string }[]>(
      this.PATH_TYPE_SERVICES + '/GetDepartamentos/' + idcliente
    );
  }

  //🥑🥑 Proveedores
  getComboProveedores(idcliente?: number): Observable<{ ID: number, NOMBRE: string }[]> {
    return this.http.get<{ ID: number, NOMBRE: string }[]>(
      this.PATH_PROVEEDORES + '/GetProveedores/' + idcliente
    );
  }
  // endregion

  getComboTipoInformes(): Observable<ComboInformesTipos[]> {
    return this.http.get<ComboInformesTipos[]>(this.PATH_INFORMES + '/Type');
  }

  getComboGrupoByCliente(idcliente: number): Observable<ComboGrupo[]> {
    return this.http.get<ComboGrupo[]>(this.PATH_CLIENTES + '/GetGroups/ ' + idcliente)
      .pipe(map(cbgrupo => cbgrupo));
  }

  getComboEstadoContenido(idcliente: number, idservicio: number): Observable<ComboEstado[]> {
    // Services/Situation/GetStatusContenido/{IdClient}/{TipoServicio}
    if (typeof idcliente !== 'undefined' && !idcliente) {
      idcliente = -1;
    }
    return this.http.get<ComboEstado[]>(this.PATH_TYPE_SERVICES + '/Situation/GetStatusContenido/' + idcliente + '/' + idservicio);

  }
}
